export default {"src":"/_next/static/media/icon_whatsapp_chatboot.89084bbb.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};